import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import Image from 'next/image';

const slidesData = [
  {
    poster:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1625151187/Remaining%20images/About/Julia_thumbnail.jpg',
    videoSrc:
      'https://res.cloudinary.com/see-sight-tours/video/upload/v1740112590/Remaining%20images/About/Julia_zwokqe.mp4',
    title: 'Julia'
  },
  {
    poster:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1625151187/Remaining%20images/About/Vinny_thumbnail.jpg',
    videoSrc:
      'https://res.cloudinary.com/see-sight-tours/video/upload/v1740112834/Remaining%20images/About/Vinny_hi19hc.mov',
    title: 'Vinny'
  },
  {
    poster:
      'https://res.cloudinary.com/see-sight-tours/image/upload/v1625151187/Remaining%20images/About/Daud_thumbnail.jpg',
    videoSrc:
      'https://res.cloudinary.com/see-sight-tours/video/upload/v1740112367/Remaining%20images/About/Dauds_Sister_no9g76.mp4',
    title: "Daud's Sister"
  }
];

const Testimonials: React.FC = () => {
  return (
    <div
      className="relative w-full h-[460px] md:h-[560px] lg:h-[848px] mt-[4rem] sm:mt-[6rem] md:mt-[10rem] xl:mt-[12rem] bg-cover bg-center"
      style={{
        backgroundImage: "url('/mask-group.png')"
      }}
    >
      <div className="absolute top-0 mr-10 left-0 right-auto sm:mr-10 sm:ml-6 md:ml-8 lg:ml-16 xl:ml-20 2xl:ml-24 transform translate-x-[3rem] sm:translate-x-[4.1rem] md:translate-x-[4.5rem] lg:translate-x-[5rem] xl:translate-x-[5rem] translate-y-[-0.5rem] sm:translate-y-[-1.5rem] md:translate-y-[-2rem] lg:translate-y-[-3rem] xl:translate-y-[-6rem] 2xl:translate-y-[-8rem]">
        <Image
          src={'/red-triangle.svg'}
          alt="red triangle"
          width={200}
          height={210}
          className="object-contain w-[6vw] sm:w-[7vw] md:w-[8vw] lg:w-[9vw] xl:w-[10vw] 2xl:w-[11vw]"
        />
      </div>

      <h2 className="text-[20px] sm:text-[24px] md:text-[40px] font-extrabold text-primary text-center pt-[2rem] md:pt-[2.5rem] lg:pt-[4rem] xl:pt-[5rem]">
        What our Guests are Saying{' '}
      </h2>

      <div className="flex justify-center items-center w-full px-10 md:px-2 lg:px-4 xl:px-44 2xl:px-80 3xl:px-88 pt-[2rem] md:pt-[2.5rem] lg:pt-[4rem] xl:pt-[5rem]">
        <Swiper
          className="swiper_123 relative w-full pb-10"
          effect="slide"
          slidesPerView={1}
          grabCursor
          a11y={{ enabled: true }}
          spaceBetween={5}
          allowSlidePrev={true}
          allowSlideNext={true}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 5
            },
            375: {
              slidesPerView: 1.1,
              spaceBetween: 5
            },
            425: {
              slidesPerView: 1.3,
              spaceBetween: 5
            },
            500: {
              slidesPerView: 1.5,
              spaceBetween: 5
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 15
            }
          }}
        >
          {slidesData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="w-[238px] h-[360px] lg:w-[303px] lg:h-[538px] rounded-[50px] overflow-hidden shadow-lg">
                <video
                  className="w-full h-full object-cover"
                  controls
                  autoPlay
                  muted
                  playsInline
                  poster={slide.poster}
                >
                  <source src={slide.videoSrc} type="video/mp4" />
                  {slide.title}
                </video>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonials;
